export default __webpack_public_path__ + "static/media/request_sent.8a93a8ad.svg";